import { Profile } from './query';
import { FileType } from '@jbc-year-end-adj/2024/types';

type Attachment = {
  name: string;
  files: FileType[];
};

export const attachmentFiles = (profile: Profile): Attachment[] => {
  const {
    formerJobs,
    workingStudentClassification,
    handicapClassification,
    generalLifeInsurances,
    nursingMedicalInsurances,
    individualAnnuityInsurances,
    earthquakeInsurances,
    socialInsurances,
    premium,
    housingLoan
  } = profile;
  const spouse = profile.dependents.filter(dependent => dependent.type === 'Spouse');
  const spouseHandicapImage = [spouse[0]?.thisYear?.handicapImage, spouse[0]?.nextYear?.handicapImage];
  const spouseRelatedToRelativesDocuments = [
    spouse[0]?.thisYear?.relatedToRelativesDocument,
    spouse[0]?.nextYear?.relatedToRelativesDocument
  ];
  const spouseRelatedToRemittanceDocuments = [
    spouse[0]?.thisYear?.relatedToRemittanceDocument,
    spouse[0]?.nextYear?.relatedToRemittanceDocument
  ];

  const otherFamilies = profile.dependents.filter(dependent => dependent.type === 'OtherFamily');
  const otherFamilyHandicapImages = otherFamilies
    .map(otherFamily => [otherFamily.thisYear?.handicapImage, otherFamily.nextYear?.handicapImage])
    .flat();
  const otherFamilyRelatedToRelativesDocuments = otherFamilies
    .map(otherFamily => [otherFamily.thisYear?.relatedToRelativesDocument, otherFamily.nextYear?.relatedToRelativesDocument])
    .flat();
  const otherFamilyRelatedToRemittanceDocuments = otherFamilies
    .map(otherFamily => [otherFamily.thisYear?.relatedToRemittanceDocument, otherFamily.nextYear?.relatedToRemittanceDocument])
    .flat();
  const otherFamilyProvingStudyAbroadDocuments = otherFamilies
    .map(otherFamily => [otherFamily.thisYear?.provingStudyAbroadDocument, otherFamily.nextYear?.provingStudyAbroadDocument])
    .flat();

  const attachments = [
    { name: '源泉徴収票', files: formerJobs.map(job => job.withholdingSlipImage) },
    { name: '学生手帳画像', files: [workingStudentClassification?.image] },
    { name: '障害者手帳画像', files: [handicapClassification?.image] },
    { name: '一般の生命保険 証明書画像', files: generalLifeInsurances.map(insurance => insurance.image) },
    { name: '介護医療保険 証明書画像', files: nursingMedicalInsurances.map(insurance => insurance.image) },
    { name: '個人年金保険 証明書画像', files: individualAnnuityInsurances.map(insurance => insurance.image) },
    { name: '地震保険 証明書画像', files: earthquakeInsurances.map(insurance => insurance.image) },
    { name: '社会保険 証明書画像', files: socialInsurances.map(insurance => insurance.image) },
    { name: '独立行政法人中小企業基盤整備機構の共済契約の掛金 証明書画像', files: [premium?.smallAndMediumSizedEnterprisesImage] },
    { name: '確定拠出年金法に規定する個人型年金加入者掛金 証明書画像', files: [premium?.personalPensionImage] },
    { name: '確定拠出年金法に規定する企業型年金加入者掛金 証明書画像', files: [premium?.corporatePensionImage] },
    { name: '心身障害者扶養共済制度に関する契約の掛金 証明書画像', files: [premium?.disabilityMutualAidImage] },
    { name: '住宅借入金等特別控除申告書の画像', files: [housingLoan?.image] },
    { name: '住宅ローンの年末残高証明書の画像', files: [housingLoan?.certificateImage] },
    { name: '配偶者・障害者手帳画像', files: spouseHandicapImage },
    { name: '扶養親族・障害者手帳画像', files: otherFamilyHandicapImages },
    { name: '扶養親族・親族関係書類', files: otherFamilyRelatedToRelativesDocuments },
    { name: '扶養親族・送金関係書類', files: otherFamilyRelatedToRemittanceDocuments },
    { name: '扶養親族・留学証明書類', files: otherFamilyProvingStudyAbroadDocuments },
    { name: '配偶者・親族関係書類', files: spouseRelatedToRelativesDocuments },
    { name: '配偶者・送金関係書類', files: spouseRelatedToRemittanceDocuments }
  ]
    .map(attachment => ({ ...attachment, files: attachment.files.filter(file => file !== undefined && file.url) as FileType[] }))
    .filter(attachment => attachment.files.length > 0);

  return attachments;
};
